export const filterIconDictionary = (key: string): string => {
  const dictionary: Record<string, string> = {
    'libre-de-lacteos': 'dairy_free',
    'libre-de-lactosa': 'lactose_free',
    'libre-de-gluten': 'gluten_free',
    'sin-tacc': 'tacc_free',
    'libre-de-soya': 'soy_free',
    'libre-de-huevo': 'egg_free',
    'libre-de-peces': 'fish_free',
    'libre-de-mariscos': 'seafood_free',
    'libre-de-frutos-secos': 'nuts_free',
    'libre-de-mani': 'peanut_free',
    'libre-de-nueces-de-arbol': 'walnuts_free',
    'libre-de-nuez': 'walnuts_free',
    'libre-de-sulfitos': 'sulphite_free',
    vegano: 'vegan',
    vegetariano: 'vegetarian',
    halal: 'halal',
    kosher: 'kosher',
    'basado-en-plantas': 'plant_based',
    'libre-de-transgenicos': 'non_gmo',
    organico: 'organic',
    'marca-chile': 'marca_chile',
    'sin-azucar-anadida': 'no_added_sugar',
    'cero-azucar': 'zero_sugar',
    'alto-en-proteinas': 'high_protein',
    // Retained for backwards compatibility
    'apto-para-diabeticos': 'diabetes_suitable',
    'apto-para-aplv': 'aplv_suitable',
    'libre-de-trigo': 'wheat_free'
  }

  return dictionary[key] || ''
}
